import { TFunction } from 'react-i18next';

const dictPrefix = 'financialPortal.settings.financialBlock';

/**
 * Frase viva de la regla de bloqueo ("Se bloqueará al estudiante que..."),
 * compartida entre el modal de parámetros (mientras se edita, con valores de
 * formulario) y el panel de parámetros (una vez guardada, con los valores
 * almacenados).
 *
 * La regla es fija — N deudas con M o más días desde su vencimiento — pero la
 * frase se mantiene porque es lo único que explica qué significan los dos
 * números de la tabla. `days`/`debts`, nunca `count`: `count` es una clave
 * reservada de i18next que activa el modo plural y rompe la búsqueda.
 */
export function getRuleSentence(
  t: TFunction,
  overdueDays: number | string,
  overdueDebtsCount: number | string,
): string {
  return t(`${dictPrefix}.rule`, {
    days: overdueDays,
    debts: overdueDebtsCount,
  });
}
